module.exports = __webpack_public_path__ + "static/media/flytebrygge.2b5115ce.svg";